import { feedbackDetails } from "@/interfaces/feedback";


function state(): feedbackDetails {
    return {
        envios: 0,
        ficheros: 0,
        id: 0,
        nombre: ""
    }

}

export default state;